export default __webpack_public_path__ + "static/media/Samuele Cottone.59d5eed0.jpg";